import { File } from "components/icons/generated";
import Box from "ds/components/Box";
import Icon from "ds/components/Icon";
import TableSimpleCell from "ds/components/TableSimple/Cell";
import { TableSimpleCellProps } from "ds/components/TableSimple/types";
import Typography from "ds/components/Typography";
import { TerraformProviderVersionArtifact } from "types/generated";

const ProviderVersionArtifactsNameCell = ({
  item: artifact,
  ...cellProps
}: TableSimpleCellProps<TerraformProviderVersionArtifact>) => {
  return (
    <TableSimpleCell {...cellProps} role="rowheader">
      <Box align="center" gap="medium">
        <Icon src={File} />
        <Typography tag="span" variant="p-body2">
          {artifact.filename}
        </Typography>
      </Box>
    </TableSimpleCell>
  );
};

export default ProviderVersionArtifactsNameCell;
